export default __webpack_public_path__ + "static/affiliate-program-PartnersAre-5-7741293cda6698c38ebedae8d4d863e1.svg";